export default {
  FlightCount__FLIGHT_COUNT: ({ flightPosition, totalFlightsInReservation }) =>
    `FLIGHT ${flightPosition} of ${totalFlightsInReservation}`,
};
